import React, { Component } from 'react'
import { CSSTransition } from "react-transition-group"
import { changeAuth, logout } from '../actions/auth'
// import { withRouter } from 'react-router-dom';
import { 
    REST_API, 
    REACT_APP_VERSION,  
    REACT_API_VERSION_URL, 
    REACT_SVC_VERSION_URL
} from '../actions/constants'

import { connect } from 'react-redux';
import { Link, Switch, Route } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";


class AboutExcelymio extends Component {


  state = {
    version: REACT_APP_VERSION,
    apiversion: "",
    apiVersionUrl: REACT_API_VERSION_URL,
    svcversion: "",
    svcVersionUrl: REACT_SVC_VERSION_URL
  }

  AbortController = new window.AbortController()

  componentDidMount() {

    this.loadData();
  }

  loadData = () => {

    let apiVersionUrl = this.state.apiVersionUrl
    let svcVersionUrl = this.state.svcVersionUrl
   
    var xmlHttp = null;

    try {

      xmlHttp = new XMLHttpRequest();
      xmlHttp.open( "GET", apiVersionUrl, false );
      xmlHttp.send( null );
      let apiversion = xmlHttp.responseText

      this.setState({"apiversion": apiversion})
    } catch(e) {

      console.log(e)
    }

    xmlHttp = null;

    try {

      xmlHttp = new XMLHttpRequest();
      xmlHttp.open( "GET", svcVersionUrl, false );
      xmlHttp.send( null )
      let svcversion = xmlHttp.responseText

      console.log(svcversion)

      this.setState({"svcversion": svcversion})
    } catch(e) {
      console.log('ERROR', e)
    }
  }

  breadCrumb() {
    let breadCrumb = window.location.href.split("/");
    return breadCrumb;
  }

  render() {

    return (

      <CSSTransition
        in={true}
        appear={true}
        timeout={5000}
        classNames="fade"
      >
        <React.Fragment>
        <div className="working-area-content">
          <div className="component-title list-group" id="working-area">
            <div className="list-group-item list-group-item-action gradient-background">
              <div className="" id="endpoint-label-wrapper">
                <div className="float-left breadcrumbs">
                  <div style={{ marginTop: '3px'}}>
                    <p>
                      <Link to={"/"}>
                        <i className="fas fa-th"></i>
                      </Link>
                      <i className="fas fa-arrow-right"></i>
                      <Link to={`/${this.breadCrumb()[3]}`}>
                        About Excelym.IO
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-5">
              <h4>                
                <div className="fa-animation" style={{ left: '40%'}}>
                    <span style={{ color: '#0FB8DB' }}>About</span>
                    <i className="fa fa-cog fa-lg fa-spin" style={{ left: '64px'}}></i>
                    <i className="fa fa-cog fa-md fa-spin" style={{ left: '84px'}}></i>                          
                    <i className="fa fa-cog fa-xs fa-spin" style={{ left: '82px'}}></i>
                    <span style={{ color: '#0FB8DB', marginLeft: '40px' }}>Excelym</span><span style={{ color: '#0056b3', marginLeft: '8px'}}><strong>IO</strong></span>
                </div>
              </h4>             
            </div>
            <table width="100%" align="center">
              <tr>
                <td align="center">
                  <table>
                    <tr><td><br /></td></tr>
                    <tr>
                      <td style={{ padding: '16px', marginTop: '5px', border: '0px solid #cccccc' }}>
                        <table>
                          <tr>
                            <td style={{ color: '#0056b3', fontSize: '1rem' }}><strong>Front end Version</strong></td>
                          </tr>
                          <tr>
                            <td style={{ fontSize: '0.875rem' }}>{this.state.version}</td>
                          </tr>
                          <tr><td><br /></td></tr>
                          <tr>
                            <td style={{ color: '#0056b3', fontSize: '1rem' }}><strong>Back end Version</strong></td>
                          </tr>
                          <tr>
                            <td style={{ fontSize: '0.875rem' }}>API Version {this.state.apiversion}</td>
                          </tr>
                          <tr>
                            <td style={{ fontSize: '0.875rem' }}>SVC Version {this.state.svcversion}</td>
                          </tr>
                          <tr><td><br /></td></tr>
                          <tr><td>
                          <button 
                              type='button' 
                              name='btn_contact_help' 
                              className='btn' 
                              onClick={(e)=>{ 
                                  window.open('https://excelym.zendesk.com/hc/en-us')
                              }}
                              >
                              Report an Issue via Excelym Help Center
                          </button></td></tr>
                          <tr><td><br /><br /><br /></td></tr>
                        </table>                       
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
        </div>
        <div className="fixed-bottom justify-content-center">  
                    <Navbar color="dark" className="">
                        <Nav className="mx-auto">
              <span style={{fontSize: '0.875rem'}}>© 2014-2022 Excelym.IO. All rights reserved.</span>
                        </Nav>
                    </Navbar>
                </div>
        </div>
        </React.Fragment>
      </CSSTransition>

    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutExcelymio)





// WEBPACK FOOTER //
// ./src/components/AboutExcelymio.js